<template>
    <b-button
        variant="primary"
        @click.stop="verificarSaldoNatureza()"
        :disabled="comprometimentosSelecionados.length == 0"
        v-if="$temAcessoView('CONT-REQ-05')"
    >
        <span
            ><i class="fa fa-check-circle-o mr-2"></i> Comprometer
            selecionados</span
        >
    </b-button>
</template>

<script>
import RequisicoesServicos from './RequisicoesServicos'

export default {
    components: {},

    props: {
        requisicao: {
            type: Object,
            default: () => ({})
        },

        comprometimentosSelecionados: {
            type: Array,
            default: () => []
        }
    },

    data() {
        return {
            saldoNaturezaOk: true
        }
    },

    methods: {
        verificarSaldoNatureza() {
            this.$store.dispatch('addRequest')
            let comprometimentosDto = {
                idContrato: this.requisicao.idContrato,
                comprometimentos: this.comprometimentosSelecionados
            }
            RequisicoesServicos.verificarSaldoNatureza(
                comprometimentosDto
            ).then((response) => {
                if (response) {
                    if (response.success) {
                        this.saldoNaturezaOk = response.data
                        this.confirmarComprometerSelecionados()
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        confirmarComprometerSelecionados() {
            let mensagem =
                'Confirma a realização dos comprometimentos selecionados no RM?'
            if (!this.saldoNaturezaOk) {
                mensagem = `Confirma a realização dos comprometimentos selecionados no RM?
                            <br/><br/>
                            <div class="alert alert-warning" role="alert">
                                <i class="fa fa-exclamation-triangle fa-lg"></i>
                                <strong>O saldo da natureza de despesa do contrato é menor que o valor total dos comprometimentos selecionados</strong>                               
                            </div>`
            }
            this.$swal({
                title: 'Comprometimento',
                html: mensagem,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then((result) => {
                if (result.value) {
                    this.comprometerSelecionados()
                }
            })
        },

        comprometerSelecionados() {
            this.$emit('comprometerSelecionados')
        }
    },

    created() {},

    computed: {},

    watch: {},

    validations: {}
}
</script>
